export enum DollarPercentVariant {
  Dollar = "Dollar",
  Percent = "Percent",
}
